import React from 'react';

function SectionHead({ title, subtitle, centered = false, amberId = '' }) {
  return (
    <div className={`mb-8 ${centered ? 'text-center' : ''}`} id={amberId || undefined}>
      <h2 className="section-heading mb-2">{title}</h2>
      {subtitle && (
        <p className="font-sans text-slate text-base leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
      <div className={`mt-3 h-1 w-16 bg-amber rounded ${centered ? 'mx-auto' : ''}`} />
    </div>
  );
}

export default SectionHead;
